import React, { useState, useEffect } from "react";
import "./ImageSlider.css";

import img1 from "../../assets/images/Awards2.jpg";
import img2 from "../../assets/images/Awards1.jpg";

const slides = [
  {
    img: img1,
    title: "Tycoons Of Maharashtra",
    text: `The Tycoon Of Maharashtra of the year 2024 is awarded to Mr. Navnath Darekar,
founder of NMD Pvt.Ltd By Mrs. Ruta Durgule Indian actress.
This award is Given For Best Businessman of the year.`,
  },
  {
    img: img2,
    title: "Success Story Continues",
    text: `This is the next slide with auto scroll and animation.
Box and image both slide in.`,
  },
];

const ImageSlider = () => {
  const [current, setCurrent] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // AUTO SLIDE
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // MOBILE CHECK
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className="slider-section">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`slide ${index === current ? "active" : ""}`}
          style={
            !isMobile
              ? { backgroundImage: `url(${slide.img})` }
              : {}
          }
        >
          {isMobile && (
            <img src={slide.img} alt={slide.title} className="slide-img" />
          )}

          <div className="overlay-text">
            <h1>{slide.title}</h1>
            {slide.text.split("\n").map((line, i) => (
              <p key={i}>{line}</p>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
};

export default ImageSlider;
